import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/agreement/service',
    name: 'ServiceAgreement',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/service'),
    meta: { title: 'Terms of Service' }
  }, { // 隐私协议
    path: '/agreement/privacy-2',
    name: 'PrivacyAgreement',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/privacy-2'),
    meta: { title: 'Privacy Policy' }
  },{
    path: '/agreement/service-2',
    name: 'ServiceAgreement',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/service-2'),
    meta: { title: 'Terms of Service' }
  }, { // 隐私协议
    path: '/agreement/privacy',
    name: 'PrivacyAgreement',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/privacy'),
    meta: { title: 'Privacy Policy' }
  }, { // 投诉指引
    path: '/agreement/complaint',
    name: 'ComplaintAgreement',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/complaint'),
    meta: { title: '投诉指引' }
  }, { // 审核不通过
    path: '/agreement/community_rules',
    name: 'CommunityRules',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/community_rules'),
    meta: { title: 'Community Rules' }
  }, { // 邀请
    path: '/agreement/invitationRule',
    name: 'invitationRule',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/invitation_rule'),
    meta: { title: 'Rules' }
  }, { // v-hot
    path: '/v-hot/guideline',
    name: 'guideline',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/guideline'),
    meta: { title: 'V-hot Guideline' }
  }, {
    path: '',
    name: 'guanwang',
    component: () => import(/* webpackChunkName: "home" */ './components/index.vue'),
    meta: { title: 'Trendo' }
  }

    , {
    path: '/views/page1',
    name: 'paeg1',
    component: () => import(/* webpackChunkName: "download" */ './views/page1/index.vue'),
    meta: { title: 'Vshots video download' }
  }, {
    path: '/agreement/flowers_strategy',
    name: 'FlowersStrategy',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/flowers_strategy.vue'),
    meta: { title: 'About Flowers' }
  }, {
    path: '/agreement/familyDescription',
    name: 'familyDescription',
    component: () => import(/* webpackChunkName: "agreement" */ './views/agreement/family_description.vue'),
    meta: { title: 'Family Description' }
  },
  {
    path: '/agreement/cancellation',
    name: 'cancellation',
    component: () => import(/* webpackChunkName: "cancellation" */ './views/agreement/cancellation.vue'),
    meta: { title: 'Cancellation & Refund' }
  },
  {
    path: '/agreement/contactUs',
    name: 'contactUs',
    component: () => import(/* webpackChunkName: "ContactUs" */ './views/agreement/contactUs.vue'),
    meta: { title: 'ContactUs' }
  },
  {
    path: '/share',
    name: 'share',
    component: () => import(/* webpackChunkName: "share" */ './views/share/index.vue'),
    meta: { title: 'share' }
  }

  ]
})

const beforeEach = (to, from, next) => {
  const title = to.meta.title ? to.meta.title : 'Trendo'
  window.document.title = title
  next()
}
router.beforeEach(beforeEach)

export default router



// WEBPACK FOOTER //
// ./src/router.js